import {
    fetchPreviewById,
    fetchUserImagesByActivityIds,
} from '@/common/service/api/Wishlist/Wishlist';
import { IActivity } from '@/entities/Activity/domain/Activity.domain';

export const getActivities = async (list: string[]): Promise<IActivity[]> => {
    const result: IActivity[] = [];

    await Promise.all(
        list.map(async (item: string) => {
            const activity = await fetchPreviewById(item);

            if (!activity?.items?.length) {
                return;
            }
            result.push(activity?.items[0]);
        })
    );

    return result;
};

export const getUserImages = (list: number[] | string[]) => {
    if (!list.length) {
        return [];
    }
    return fetchUserImagesByActivityIds(list.join(','));
};
